export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || '';
export const GTM_AUTH = process.env.NEXT_PUBLIC_GTM_AUTH || '';
export const GTM_PREVIEW = process.env.NEXT_PUBLIC_GTM_PREVIEW || '';
export const GTM_CUSTOM_URL = process.env.NEXT_PUBLIC_GTM_CUSTOM_URL || '';
export const GTM_DATA_LAYER = process.env.NEXT_PUBLIC_GTM_DATA_LAYER || 'dataLayer';
